import { MenuItem, Typography } from '@material-ui/core'
import { BlockUser } from 'common/icon-components/BlockUser'
import { CloseReport } from 'common/icon-components/CloseReport'
import { SuspendUser } from 'common/icon-components/SuspendUser'
import { ReportedContentAction } from 'common/types'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { Dispatch, PropsWithChildren, SetStateAction, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { useReportedUser } from '../hooks/useReportedUser'
import { ReopenReport } from 'common/icon-components/ReopenReport'
import { DeleteReportedContentIcon } from 'common/icon-components/DeleteReportedContentIcon'
import { AssignReportIcon } from 'common/icon-components/AssignReportIcon'
import { observer } from 'mobx-react'
import { ReportedContentState } from 'models/reported-content/reported-content.store'

const StyledMenuText = styled(Typography)`
  && {
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.5rem;
    color: ${({ theme }) => theme.colors.accent1};
  }
`
const StyledMenuItem = styled(MenuItem)`
  && {
    gap: 1.7rem;
    padding-left: 2.25rem;
  }
`
interface IReportDetailsMenuItemProps {
  handleClose: () => void
}

const ReportDetailsMenuItem = ({ handleClose }: PropsWithChildren<IReportDetailsMenuItemProps>) => {
  const {
    isAssignedToMyself,
    reportedContent,
    setShowSuspendUser,
    setShowBlockUser,
    shouldDisableAllActions,
    setShowCloseReportModal
  } = ReportedContentState
  const { handleAssignToSelf } = useReportedUser()
  const { reportId } = useParams<{ reportId: string }>()
  const { backendUser } = useAuth()

  const parsedUrl = new URL(window.location.href)
  const contentDeleted = JSON.parse(parsedUrl.searchParams.get('contentDeleted'))
  const isClosed = reportedContent?.status === 'closed'

  const ReportedAction = [
    {
      label: ReportedContentAction.ASSIGN_TO_MYSELF,
      icon: <AssignReportIcon />,
      action: () => handleAssignToSelf('assignedTo')
    },
    {
      label: ReportedContentAction.DELETE_POST,
      icon: <DeleteReportedContentIcon />,
      action: () => {}
    },
    {
      label: ReportedContentAction.SUSPEND_USER,
      icon: <SuspendUser />,
      action: () => setShowSuspendUser(true)
    },
    {
      label: ReportedContentAction.BLOCK_USER,
      icon: <BlockUser />,
      action: () => setShowBlockUser(true)
    },
    {
      label: isClosed ? ReportedContentAction.REOPEN_CLOSED_REPORT : ReportedContentAction.CLOSE_REPORTED_CONTENT,
      icon: isClosed ? <ReopenReport /> : <CloseReport />,
      action: () => (isClosed ? setShowCloseReportModal(false) : setShowCloseReportModal(true))
    }
  ]

  return (
    <div>
      {ReportedAction.map((action, index) => {
        return (
          <StyledMenuItem
            key={index}
            disabled={
              (!isAssignedToMyself(backendUser) && action.label !== ReportedContentAction.ASSIGN_TO_MYSELF) ||
              (!contentDeleted &&
                isAssignedToMyself(backendUser) &&
                action.label === ReportedContentAction.SUSPEND_USER) ||
              (!contentDeleted &&
                isAssignedToMyself(backendUser) &&
                action.label === ReportedContentAction.BLOCK_USER) ||
              (shouldDisableAllActions &&
                action.label !== ReportedContentAction.ASSIGN_TO_MYSELF &&
                action.label !== ReportedContentAction.REOPEN_CLOSED_REPORT &&
                reportedContent?.status === 'closed')
            }
            onClick={() => {
              handleClose()
              action.action()
            }}
          >
            {action.icon}
            <StyledMenuText>{action.label}</StyledMenuText>
          </StyledMenuItem>
        )
      })}
    </div>
  )
}

export default observer(ReportDetailsMenuItem)
